import React from 'react';
import { Card } from '../../../../../../components/Card/Card';
import { KeyValueTable } from '../../../../../../components/KeyValueTable/KeyValueTable';
import { t } from '../../../../../../locales/translate';
import { withSuspendedCard } from '../../../../../../util/suspense';
import { useSuspenseQuery } from '../../../../../../util/use_suspense_query';
import { graphql } from '../../../../../../generated';
import { Stack } from '../../../../../../components/Stack/Stack';
import { Icon } from '../../../../../../components/Icon/Icon';
import { EditTicketLayoutModal } from './edit_ticket_layout';
import { useModalPresenter } from '../../../../../../components/Modal/PresentedModal';

const EVENT_TICKET_LAYOUT_QUERY = graphql(`
  query EventTicketLayouts($eventId: ID!) {
    event(id: $eventId) {
      id
      permissions {
        id
        update
      }
      ticketLayout
      onlineTicketLayout
      localTicketLayout
    }
  }
`);

interface Props {
  eventId: string;
}

function TicketLayouts$({ eventId }: Props): JSX.Element {
  const modal = useModalPresenter();

  const { data } = useSuspenseQuery(EVENT_TICKET_LAYOUT_QUERY, {
    variables: { eventId },
  });

  return (
    <Card title={t.page.event.design.ticketLayouts.title}>
      <KeyValueTable
        labelWidth={300}
        items={[
          {
            key: t.model.ticket.ticketLayout,
            value: (
              <Stack line>
                {data.event.ticketLayout.toLowerCase().replace(/_/g, '-')}
                {data.event.permissions.update && (
                  <Icon
                    color="var(--color-text-label)"
                    name="edit--sm"
                    onClick={() => modal.present(EditTicketLayoutModal, { eventId, ticketVariant: 'HARD' })}
                  />
                )}
              </Stack>
            ),
          },
          {
            key: t.model.ticket.onlineTicketLayout,
            value: (
              <Stack line>
                {data.event.onlineTicketLayout.toLowerCase().replace(/_/g, '-')}
                {data.event.permissions.update && (
                  <Icon
                    color="var(--color-text-label)"
                    name="edit--sm"
                    onClick={() => modal.present(EditTicketLayoutModal, { eventId, ticketVariant: 'ONLINE' })}
                  />
                )}
              </Stack>
            ),
          },
          {
            key: t.model.ticket.localTicketLayout,
            value: (
              <Stack line>
                {data.event.localTicketLayout.toLowerCase().replace(/_/g, '-')}
                {data.event.permissions.update && (
                  <Icon
                    color="var(--color-text-label)"
                    name="edit--sm"
                    onClick={() => modal.present(EditTicketLayoutModal, { eventId, ticketVariant: 'LOCAL' })}
                  />
                )}
              </Stack>
            ),
          },
        ]}
      />
    </Card>
  );
}

export const TicketLayouts = withSuspendedCard(TicketLayouts$, { loadingTitle: t.model.ticket.ticketLayout });
